// React Component
import { useRouteError, NavLink } from "react-router-dom"

// App Component
import { Colors, Images } from "../../constants"
// import { BodyLayout } from "../../layouts"
import { Routes } from "../../routes"
import { useTranslation } from "react-i18next"
import { useBranding } from "../../contexts/BrandingContext"
import { useTheme } from "../../contexts/ThemeContext"

const Error404View = () => {
    const errors = useRouteError() as Error
    const { t } = useTranslation();
    const { theme } = useTheme();
    const { getLogo, branding } = useBranding();
    const displayLogo = getLogo(theme) || Images.famla;
    console.error('error', errors)

    return (
        <div className="vh-100" style={{ backgroundImage: `url(${Images.bg_1})`, backgroundSize: 'cover' }}>
            <div className="vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: Colors.bg_dark_blur_2 }}>
                <div className="d-flex flex-column align-items-center">
                    <div className="me-3">
                        <img src={displayLogo} alt={branding.appName} className="img-fluid" style={{ maxWidth: 300, maxHeight: 150, objectFit: 'contain' }} />
                    </div>

                    <div>
                        <h1 className="text-light mb-3" style={{ fontSize: "5rem" }}>{t('navigation.oops')}</h1>
                        {/* <p className="text-light fs-2 mb-3">{t('navigation.simplyLeverage')}</p> */}
                        <p>
                            {/* <i>{errors.message}</i>  */}
                        </p>
                    </div>
                    <NavLink to={Routes.HOMEVIEW} className="btn btn-theme fw-bold px-5 mt-3 d-flex align-items-center justify-content-center">{t('navigation.backHome')}</NavLink>

                </div>
            </div>
        </div>
    )
}

export default Error404View